import { Checkbox, Space } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { ComponentProps } from 'react'
import * as React from 'react'

interface Props extends ComponentProps<typeof Checkbox> {
  onCheck?: (checked: boolean) => void
  showCheckbox?: boolean
  align?: ComponentProps<typeof Space>['align']
}

const CheckboxRow: React.FC<Props> = ({
  onCheck,
  checked,
  children,
  showCheckbox = true,
  align,
  ...others
}) => {
  const onChange = (e: CheckboxChangeEvent) => {
    onCheck && onCheck(e.target.checked)
  }

  return (
    <Space align={align}>
      <If condition={showCheckbox}>
        <Checkbox
          onChange={onChange}
          checked={checked}
          style={{ alignSelf: 'center', width: '30px' }}
          {...others}
        />
      </If>
      {children}
    </Space>
  )
}
export default CheckboxRow
